export enum ContentAppearancePropertyKey {
	PUBLISHED = 'content-appearance-published',
	DRAFT = 'content-appearance-draft',
}

type ContentAppearanceContentProperty = {
	readonly key: ContentAppearancePropertyKey | string | null | undefined;
	readonly value: string | null | undefined;
	readonly version?: {
		readonly number: number | null | undefined;
	} | null;
};

export type GraphqlAppearanceContentProperty = {
	readonly nodes:
		| ReadonlyArray<ContentAppearanceContentProperty | null | undefined>
		| null
		| undefined;
};

export type GraphqlQueryContentWithDraftAppearance = {
	readonly appearanceDraft: GraphqlAppearanceContentProperty | null | undefined;
};

export type GraphqlQueryContentWithPublishedAppearance = {
	readonly appearancePublished: GraphqlAppearanceContentProperty | null | undefined;
};

export type ContentAppearance = {
	appearance: ContentAppearanceType;
	version: number;
};

export enum ContentAppearanceType {
	DEFAULT = 'default',
	FULL_WIDTH = 'full-width',
	MAX = 'max',
}

export type FullPageAppearances = 'full-page' | 'full-width' | 'max';

export type ContentAppearanceToAtlaskitMap = {
	[key in ContentAppearanceType]: FullPageAppearances;
};

export type EditorWidthMetadata = {
	value: ContentAppearanceType;
	version: number;
};

export type UpdateContentAppearancePropertyBody = {
	contentId: string;
	propertyKey: ContentAppearancePropertyKey;
	propertyValue: ContentAppearanceType;
	versionNumber: number;
};
